import Request from '@/plugins/request'

export function getWarehouseGoodLogs(params) {
  return Request.get('warehouse-good-logs', { params })
}

export function createWarehouseGoodLog() {
  return Request.get(`warehouse-good-logs/create`)
}

export function storeWarehouseGoodLog(data) {
  return Request.post('warehouse-good-logs', data)
}

export function updateWarehouseGoodLog(id, data) {
  return Request.put(`warehouse-good-logs/${id}`, data)
}

export function editWarehouseGoodLog(id) {
  return Request.get(`warehouse-good-logs/${id}/edit`)
}

export function destroyWarehouseGoodLog(id) {
  return Request.delete(`warehouse-good-logs/${id}`)
}
